<template>
  <div class="order-view">
    <b-alert variant="danger" :show="orderData === undefined">
      <h4 class="alert-heading">Error fetching order data</h4>
      <div class="alert-body">
        No record found with this id. Check
        <b-link class="alert-link" :to="{ name: 'order-list' }">
          order List
        </b-link>
        for other record.
      </div>
    </b-alert>

    <modal-image-viewer :id="custome_id" :image-list="previewImage" :selected_file="selected_file"></modal-image-viewer>

    <div v-if="user_type_id == 2 && project_list.length > 0"
      class="row justify-content-end align-items-center mr-2 mb-2">
      <span class="">項目：</span>
      <v-select :options="project_list" label="project_name" :reduce="(project) => project.id" :clearable="false"
        v-model="selected_project_id" @input="onProjectChange(selected_project_id)" placeholder="選擇項目"
        :filter="projectSearch" style="max-width: 400px; width:100%" class="">
        <template #option="{ project_name, project_number, address }">
          [{{ project_number }}] {{ project_name }} - {{ address }}
        </template>
        <template #selected-option="{ project_name, project_number, address }">
          [{{ project_number }}] {{ project_name }} - {{ address }}
        </template>
      </v-select>
    </div>

    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <h1 v-if="loading" class="d-flex justify-content-center"></h1>
      <div v-if="orderData && orderData.id > 0">
        <modal-document :project_id="project_id" :document-data="documentData" @refetch-data="refetchData" />

        <modal-stage-document :document-data="stageDocumentData" @refetch-data="refetchData" />

        <modal-message :project_id="project_id" :messageData="messageData" :commentTypeOptions="commentTypeOptions"
          @refetch-data="refetchData" />

        <modal-drawing :project_id="project_id" :drawingData="drawingData" @refetch-data="refetchData" />

        <modal-appointment :project_id="project_id" :is_customer="user_type_id == 2" :appointmentData="appointmentData"
          :bookingStatusOptions="bookingStatusOptions" @refetch-data="refetchData" />

        <!-- <modal-activitice
          :project_id="project_id"
          :activiticeData="activiticeData"
          :activiticeTypeOptions="activiticeTypeOptions"
          :workerOptions="workerOptions"
          @refetch-data="refetchData"
        /> -->

        <modal-progress-edit :project_id="project_id" :progressList="progressList"
          @refetch-data="refetchData"></modal-progress-edit>

        <modal-drawing-approval :approve-data="approveData" @refetch-data="refetchData" />

        <Modal-Pdf :title="title" :pdf-url="pdfUrl" />

        <b-card no-body class="p-1 px-2">
          <!-- order Info: Top col -->
          <div class="d-flex flex-wrap align-items-center justify-content-between">
            <h5 class="mb-0 ml-0 mb-1 mb-sm-0 font-weight-bolder d-flex text-nowrap align-items-center">
              <font-awesome-icon class="mr-50 ml-1" icon="fa-solid fa-list-check" />
              訂單資料
            </h5>
            <div class="d-flex flex-wrap justify-content-end">
              <b-button v-if="ability.can('read', 'projects')" class="mobile-w100 mb-1 px-3 mx-1" type="button"
                variant="outline-secondary" @click="hide">
                返回
              </b-button>
              <b-button v-if="ability.can('update', 'projects')"
                class="px-3 mx-1 mobile-w100 mb-1 backgroundColor1 no-border" :to="{
                  name: 'project-edit',
                  params: { id: orderData.id },
                }"><feather-icon class="mr-50" size="14" icon="Edit2Icon" />修改</b-button>
              <b-button class="px-3 mx-1 mobile-w100 mb-1 backgroundColor0 colorWhite no-border"
                style="line-height: 1.2" type="button" variant="outline-secondary" @click="handleModelDocument(false)"
                v-if="
                  ability.can(
                    'project_stages_customer_document_upload',
                    'order_detail'
                  ) && orderData.is_completed == 0
                ">
                <feather-icon class="mr-25" size="18" icon="PlusIcon"></feather-icon>
                客戶提供參考相片
              </b-button>
              <b-button class="px-3 mx-1 mobile-w100 mb-1 colorWhite no-border" style="background-color: #6c4a9a"
                variant="outline-danger" v-if="
                  ability.can('comment_create', 'order_detail') &&
                  orderData.is_completed == 0
                " @click="handleMessage(false)">
                <font-awesome-icon class="mr-50" icon="fa-solid fa-message" />撰寫評論</b-button>
              <b-button class="px-3 mx-1 mobile-w100 mb-1 colorWhite no-border" style="background-color: #219652"
                variant="outline-danger" v-if="
                  ability.can('appointment_create', 'order_detail') &&
                  orderData.is_completed == 0
                " @click="handleAppointment(false)">
                <font-awesome-icon class="mr-25" icon="fa-solid fa-clock" />
                預約時間</b-button>
            </div>
          </div>
          <hr />
          <b-row class="info-wrap px-1">
            <b-col cols="12" sm="12" md="7">
              <b-row>
                <b-col cols="12" sm="3">
                  <div class="mb-1">
                    <label class="mr-50">編號：</label>{{ orderData.project_number }}
                  </div>
                  <h4 class="mb-0 font-weight-bolder">
                    {{ orderData.project_name }}
                  </h4>
                  <div class="">
                    {{ orderData.address }}
                  </div>
                  <div class="mt-50">
                    <label>項目摘要：</label>
                    <div class="" style="overflow-x: auto;white-space: nowrap;" :title="orderData.project_description">
                      {{ orderData.project_description }}
                    </div>
                  </div>
                </b-col>

                <b-col cols="12" sm="4">
                  <div class="info-item">
                    <b class="info-item-label">單據抬頭：</b>
                    <span>{{ orderData.name_cn }}</span>
                  </div>
                  <div class="info-item">
                    <b class="info-item-label">系統帳號名稱：</b>
                    <span>{{ orderData.name }}</span>
                  </div>
                  <div class="info-item">
                    <b class="info-item-label">聯絡電話：</b>
                    <span>{{ orderData.phone }}</span>
                  </div>
                  <div class="info-item">
                    <b class="info-item-label">電郵地址：</b>
                    <span>{{ orderData.email }}</span>
                  </div>
                </b-col>

                <b-col cols="12" sm="5">
                  <div class="info-item">
                    <b class="info-item-label">預定工期：</b>
                    <span class="date-range">{{ orderData.expect_start_date }} - {{ orderData.expect_end_date }}</span>
                  </div>
                  <div class="info-item">
                    <b class="info-item-label">工程經理：</b>
                    <span>
                      {{ getManager(orderData.manager_id) }}
                    </span>
                  </div>

                  <div class="info-item">
                    <b class="info-item-label">總金額：</b>
                    <span>{{ formatCurrency(orderData.total_amount) }}</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12" sm="12" md="5">
              <b-row>
                <b-col cols="12" sm="6">
                  <div class="info-item">
                    <b class="info-item-label">項目狀態：</b>
                    <span>{{
                      getProjectStatus(orderData.project_status_id)
                    }}</span>
                  </div>

                  <!-- <div class="info-item">
                    <b class="info-item-label">總期數：</b>
                    <span>{{ orderData.period }}期</span>
                  </div> -->
                  <!-- <div class="info-item">
                    <b class="info-item-label">已付金額：</b>
                    <span>{{
                      (orderData.invoice && orderData.invoice.total_paid) ||
                      orderData.total_paid
                      }}</span>
                  </div> -->
                  <div class="info-item">
                    <b class="info-item-label">已付款：</b>
                    <span>{{ formatCurrency(orderData.total_paid) }}</span>
                    <!-- <span>{{
                      (orderData.invoice && orderData.deposit_amount) ||
                      orderData.deposite
                      }}</span> -->
                  </div>

                  <div class="info-item">
                    <b class="info-item-label">餘額：</b>
                    <span>{{ formatCurrency(orderData.total_amount - orderData.total_paid) }}</span>
                  </div>
                </b-col>
                <b-col cols="12" sm="6">
                  <div class="info-item">
                    <b class="info-item-label">完工狀態：</b>
                    <span :class="orderData.is_completed ? 'text-success' : 'text-danger'
                      ">{{ orderData.is_completed ? "已完工" : "未完工" }}</span>
                  </div>

                  <div class="info-item">
                    <b class="info-item-label">創建日期：</b>
                    <span>{{
                      orderData.created_at && orderData.created_at.slice(0, 10)
                    }}</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
        <!-- 發票記錄 -->
        <b-card class="no-min expenditure-box" v-if="ability.can('invoices', 'order_detail')">
          <div style="background-color: #e1f2fe" class="colored-tab-title">
            <h4 class="d-flex aling-items-center p-1 left-bold-border before-color-0 font-weight-bolder">
              發票記錄
            </h4>
          </div>
          <div class="mt-2">
            <b-table ref="refInvoiceListTable" class="order-table-invoice position-relative" :items="invoicesList"
              responsive :fields="invoiceColumns" primary-key="id" show-empty empty-text="未找到匹配的記錄">
              <!-- Column: invoice_type -->
              <template #cell(invoice_type)="data">
                {{
                  getInvoiceType(data.item.invoice_type_id) &&
                  getInvoiceType(data.item.invoice_type_id).name
                }}
              </template>

              <template #cell(quotation_id)="data">
                {{
                  getQuotation(data.item.quotation_id) &&
                  getQuotation(data.item.quotation_id).quotation_number
                }}
              </template>

              <template #cell(invoice_number)="data">
                <b-link :to="{ name: 'invoice-edit', params: { id: data.item.id } }" class="text-primary">
                  {{ data.item.invoice_number }}
                  </b-link>
              </template>

              <template #cell(total_unpaid)="data">
                {{ data.item.total_amount - data.item.total_paid }}
              </template>

              <!-- Column: cost_items -->
              <template #cell(show_details)="row">
                <b-button v-if="row.item.cost_items" size="sm" @click="toggleItemDetails(row)" class="mr-2">
                  {{ getItemDetailsShowing(row.item.id) ? "隱藏" : "顯示" }}
                </b-button>
              </template>

              <!-- Column: payment_steps -->
              <template #cell(show_details2)="row">
                <b-button v-if="
                  (row.item.payment_steps && row.item.payment_steps.length > 0) ||
                  (row.item.paymentSteps && row.item.paymentSteps.length > 0)
                " size="sm" @click="togglePaymentStepsDetails(row)" class="mr-2" variant="primary">
                  {{ getPaymentStepsShowing(row.item.id) ? "隱藏" : "顯示" }}
                </b-button>
                <span v-else class="text-muted">還沒設置階段收費</span>
              </template>

              <template #row-details="row">
                <!-- 項目摘要詳情 -->
                <div v-if="getItemDetailsShowing(row.item.id)">
                  <div class="info-container" v-if="row.item.salary_items && row.item.salary_items.length">
                    <b-row class="p-2 backgroundColor5 mb-1" v-for="(worker, index) in row.item.salary_items"
                      :key="`cost${index}`">
                      <b-col cols="12" md="3">
                        <div class="row mb-50">
                          <b class="label">師傅：</b>
                          <span>{{ getWorkerName(worker.worker_id) }}</span>
                        </div>
                        <div class="row mb-50">
                          <b class="label">職位：</b>
                          <span>{{ worker.position }}</span>
                        </div>
                        <div class="row mb-50">
                          <b class="label">工資：</b>
                          <span>{{ worker.working_days }}天 * ${{
                            Number(worker.day_salary).toFixed(2)
                            }}每日 = ${{
                              Number(worker.total_salary).toFixed(2)
                            }}</span>
                        </div>
                      </b-col>
                      <b-col cols="12" md="3">
                        <div class="row mb-50">
                          <b class="label">開工日期：</b>
                          <pre>{{ worker.working_date }}</pre>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="info-container" v-if="row.item.cost_items && row.item.cost_items.length">
                    <b-row class="p-2 backgroundColor3 mb-1" v-for="(cost, index) in row.item.cost_items"
                      :key="`cost${index}`">
                      <b-col cols="12" md="3">
                        <div class="row mb-50">
                          <b class="label">商品分類：</b>
                          <span>{{
                            getProductCategory(cost.product_category_id) &&
                            getProductCategory(cost.product_category_id).name
                            }}</span>
                        </div>

                        <div class="row mb-50">
                          <b class="label">商品：</b>
                          <span>{{
                            getProduct(cost.product_id) &&
                            getProduct(cost.product_id).product_name
                            }}</span>
                        </div>

                        <div class="row mb-50">
                          <b class="label">金額：</b>
                          <span>{{ parseFloat(Number(cost.quantity).toString()) }}
                            {{ getProduct(cost.product_id).unit }}

                            * ${{ Number(cost.unit_price).toFixed(2) }} = ${{
                              Number(cost.amount).toFixed(2)
                            }}</span>
                        </div>
                      </b-col>
                      <b-col cols="12" md="3">
                        <div class="row mb-50">
                          <b class="label">增加空行數量：</b>
                          <pre class="mb-0">{{ cost.empty_rows }}</pre>
                        </div>
                        <div class="row mb-50">
                          <b class="label">備註/尺寸：</b>
                          <span class="mb-0">{{ cost.item_description }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>

                <!-- 階段收費詳情 -->
                <div v-if="getPaymentStepsShowing(row.item.id)" class="payment-steps-details">
                  <div class="info-container">
                    <h6 class="mb-3 text-primary">
                      <feather-icon icon="CreditCardIcon" size="16" class="mr-1" />
                      階段收費詳情
                      <span v-if="row.item.payment_steps_title" class="text-muted">
                        - {{ row.item.payment_steps_title }}
                      </span>
                    </h6>
                    <div v-if="
                      getPaymentStepsData(row.item) &&
                      getPaymentStepsData(row.item).length > 0
                    ">
                      <b-row class="p-1 mb-1 backgroundColor2 border-left-primary"
                        v-for="(step, index) in getPaymentStepsData(row.item)" :key="`payment_step_${index}`">
                        <b-col cols="12" class="d-flex">
                          <div class="d-flex mr-2">
                            <b class="label">階段：</b>
                            <span>{{ step.step_phase }}</span>
                          </div>

                          <div class="d-flex mr-2">
                            <b class="label">佔比：</b>
                            <span class="text-info font-weight-bold">{{ step.step_percentage }}%</span>
                          </div>

                          <div class="d-flex mr-2">
                            <b class="label">金額：</b>
                            <span class="text-success font-weight-bold">${{ Number(step.step_amount).toFixed(2)
                              }}</span>
                          </div>

                          <div class="d-flex" v-if="step.step_name">
                            <b class="label">備註：</b>
                            <span>{{ step.step_name }}</span>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="p-1 mb-1 backgroundColor2 border-left-primary">
                        <small class="text-info">
                          <strong>總計：</strong>
                          {{
                            getPaymentStepsData(row.item)
                              .reduce(
                                (sum, step) => sum + Number(step.step_percentage),
                                0
                              )
                              .toFixed(2)
                          }}% = ${{
                            getPaymentStepsData(row.item)
                              .reduce(
                                (sum, step) => sum + Number(step.step_amount),
                                0
                              )
                              .toFixed(2)
                          }}
                        </small>
                      </b-row>
                    </div>
                    <div v-else class="text-center text-muted py-3">
                      <feather-icon icon="InfoIcon" size="16" class="mr-1" />
                      此發票沒有設置階段收費信息
                    </div>
                  </div>
                </div>
              </template>

              <!-- Column: stamp -->
              <template #cell(stamp)="data">
                <feather-icon v-if="data.item.stamp" icon="CheckIcon" size="18" class="mr-50 text-success" />
              </template>

              <template #cell(created_at)="data">
                {{ getDateTime(data.item.created_at) }}
              </template>

              <template #cell(actions)="data">
                <b-link v-if="ability.can('invoices_print', 'order_detail')" :to="{
                  name: 'invoices-preview',
                  params: { id: data.item.id },
                }">
                  <feather-icon icon="FileTextIcon" />
                  <span class="align-middle ml-50">列印發票</span>
                </b-link>
                <!-- <b-link
                v-if="ability.can('update', 'invoices') "
                :to="{
                  name: 'receipt-create',
                  query: { invoice_id: data.item.id },
                }"
                class="ml-1"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">生成收據</span>
              </b-link> -->
              </template>
            </b-table>
          </div>
        </b-card>

        <!-- 預期進度 -->
        <b-card v-if="ability.can('project_stages', 'order_detail')">
          <div class="d-flex align-items-center justify-content-between">
            <h4 class="d-flex aling-items-center p-1 left-bold-border before-color-1 font-weight-bolder">
              <!-- 預期進度 -->
              施工進度
            </h4>
            <b-button variant="primary" class="d-flex py-50 px-3 align-items-center" @click="handleProgressEdit" v-if="
              ability.can('project_stages_update', 'order_detail') &&
              orderData.is_completed == 0
            ">
              <font-awesome-icon class="mr-50" icon="fa-solid fa-pen" />
              更新</b-button>
          </div>
          <div class="p-2">
            <div style="border: 1px solid #69c1f8"
              class="d-flex flex-wrap flex-lg-nowrap color1 p-50 radius-round align-items-center justify-content-center">
              <font-awesome-icon class="mr-50 d-none d-sm-inline" icon="fa-solid fa-calendar" />
              預定工期:
              <div class="date-range">
                {{ orderData.expect_start_date }} 至 {{ orderData.expect_end_date }}
              </div>
            </div>
            <div v-if="
              orderData.project_stages && orderData.project_stages.length > 0
            " class="time-line-group d-flex flex-wrap align-items-end justify-content-between">
              <div class="group">
                <app-timeline class="horizontal mt-3">
                  <app-timeline-item :icon="item.is_completed
                    ? '@/assets/images/icons/tick.png'
                    : '@/assets/images/icons/question.png'
                    " :class="item.is_completed ? 'active' : null" v-for="item in orderData.project_stages"
                    :key="item.id">
                    <div class="timeline-item-content" :class="item.is_completed ? 'active' : null">
                      <div class="text mb-50">
                        {{ item.name }}
                      </div>
                      <div>
                        {{ item.complete_date }}
                      </div>
                    </div>
                  </app-timeline-item>
                </app-timeline>
              </div>
            </div>
          </div>
        </b-card>

        <!-- 進度表 及 工程文件-->
        <b-row>
          <!-- 進度表 -->
          <b-col xl="6" v-if="ability.can('project_stages_user_document', 'order_detail')">
            <b-card style="height: calc(460px - 2rem)">
              <div class="d-flex align-items-center justify-content-between">
                <h4 class="mb-0 ml-1 d-flex aling-items-center left-bold-border before-color-0 font-weight-bolder">
                  員工施工相片
                </h4>
              </div>
              <div class="mt-2 progress-list-container" style="height: 345px; overflow-y: auto">
                <div v-if="
                  orderData.project_stage_info &&
                  orderData.project_stage_info.length > 0
                ">
                  <div :class="`d-flex px-2 time-list radius-round align-items-center mb-50 ${findCompletedItem(orderData.project_stage_info, time)
                      ? 'active'
                      : ''
                    }`" v-for="(time, index) in orderData.project_stage_info" :key="`time${index}`">
                    <div class="time-part">
                      <div class="month">
                        {{
                          monthList[Number(time.info_date.split("-")[1] - 1)]
                        }}
                      </div>
                      <div class="day">
                        {{ Number(time.info_date.split("-")[2]) }}
                      </div>
                    </div>
                    <div class="info-part">
                      <div class="d-flex py-2 py-xl-1 flex-wrap justify-content-between align-items-center">
                        <div>
                          <h5 class="name text-nowrap mt-1">{{ time.title }}</h5>
                          <p class="desc text-nowrap">{{ time.description }}</p>
                        </div>
                        <div>
                          <div style="gap:10px" class="d-flex flex-wrap align-items-center">
                            <div v-if="
                              findCompletedItem(
                                orderData.project_stage_info,
                                time
                              )
                            ">
                              完成
                              <b-badge class="current-stage text-nowrap">
                                {{
                                  time.project_stage && time.project_stage.name
                                }}
                              </b-badge>
                            </div>
                            <div v-else>
                              <b-badge class="stage">
                                {{
                                  time.project_stage && time.project_stage.name
                                }}
                              </b-badge>
                            </div>
                            <b-button variant="primary" class="d-flex py-50 px-50 ml-2 align-items-center"
                              @click="handleStageModelDocument(time)" v-if="
                                ability.can(
                                  'project_stages_user_document_upload',
                                  'order_detail'
                                ) && orderData.is_completed == 0
                              ">
                              <feather-icon icon="PlusIcon" size="20" />
                              <!-- 上傳 -->
                            </b-button>
                            <b-button v-if="time.files && time.files.length > 0" variant="outline-primary"
                              class="d-flex py-50 px-2 ml-2 align-items-center" @click="showAllImages(time)"
                              :aria-expanded="show_all_images_id == time.id ? 'true' : 'false'">
                              <feather-icon :icon="show_all_images_id == time.id ? 'ChevronUpIcon' : 'ImageIcon'"
                                size="16" class="mr-50" />
                              {{ show_all_images_id == time.id ? "隱藏" : "顯示" }}
                            </b-button>
                            <div class="ml-2" v-else>沒有圖片</div>
                          </div>
                        </div>
                      </div>
                      <div v-if="
                        time.files &&
                        time.files.length > 0 &&
                        show_all_images_id == time.id
                      ">
                        <div v-for="(file, idx) in time.files" :key="file.id"
                          class="py-1 border-top d-flex align-items-center">
                          <!-- PDF文件顯示 -->
                          <embed
                            v-if="file.image_path && file.image_path.toLowerCase().includes('.pdf')"
                            class="pdf"
                            style="max-width: 100px; max-height: 100px"
                            :src="file.image_path"
                            type="application/pdf"
                          />
                          <!-- 圖片文件顯示 -->
                          <img
                            v-else
                            :src="file.image_path"
                            alt="file.name"
                            class="img-thumbnail mr-2"
                          />
                          <a class="color1" @click="preview_stage_images(time, idx)">預覽</a>
                          <span class="ml-2">{{
                            file.user && file.user.name_cn
                          }}</span>
                          <span class="ml-2">{{
                            file.created_at && getDateTime(file.created_at)
                          }}</span>
                          <!-- ||
                          (file.user && file.user.id == user_id)) -->
                          <a v-if="
                            orderData.is_completed == 0 &&
                            ability.can(
                              'project_stages_user_document_delete',
                              'order_detail'
                            )
                          " class="delete colorRed ml-2" @click="
                            deleteRecord(file.id, 'deleteStageInfoFile')
                            ">刪除</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-grid place-items-center" v-else>
                  未找到匹配的記錄
                </div>
              </div>
            </b-card>
          </b-col>
          <!-- 工程文件 -->

          <b-col xl="6" v-if="
            ability.can('project_stages_customer_document', 'order_detail')
          ">
            <b-card style="height: calc(460px - 2rem)" id="downloadWrapper">
              <div class="d-flex align-items-center justify-content-between">
                <h4 class="mb-0 ml-0 d-flex aling-items-center left-bold-border before-color-2 font-weight-bolder">
                  客戶提供參考相片
                </h4>
                <b-button variant="primary" class="d-flex py-50 px-2 align-items-center"
                  @click="handleModelDocument(false)" v-if="
                    ability.can(
                      'project_stages_customer_document_upload',
                      'order_detail'
                    ) && orderData.is_completed == 0
                  ">
                  <feather-icon icon="PlusIcon" size="20" />
                  上傳</b-button>
              </div>
              <div class="mt-2" style="height: 345px; overflow-y: auto">
                <b-table ref="refOrderDocumentsTable" class="position-relative" :items="orderData.project_documents"
                  responsive :fields="documentTableColumns" primary-key="id" show-empty empty-text="未找到匹配的記錄">
                  
                  <template #cell(name)="data">
                    {{ (!data.item.name || data.item.name == "undefined") ? '- -' : data.item.name }}
                  </template>
                  
                  <!-- Column: file_url -->
                  <template #cell(file_url)="data">
                    <!-- <a target="_blank" :href="data.item.file_url">下載</a> -->
                    <a class="color1" @click="
                      previewImageSet(
                        orderData.project_documents,
                        data.index,
                        'project_documents'
                      )
                      ">預覽</a>
                  </template>

                  <template #cell(created_at)="data">
                    {{ getDateTime(data.item.created_at) }}
                  </template>

                  <template #cell(files)="data">
                    <div class="d-flex" v-for="file of data.item.files" :key="`files${file.id}`">
                      <a class="d-flex" target="_blank" :download="file.file_name" :href="file.image_path">
                        <span class="download-text d-inline-block">{{
                          file.file_name
                        }}</span>
                        <!-- 下載 -->
                      </a>
                      <a v-if="
                        ability.can(
                          'project_stages_customer_document_delete',
                          'order_detail'
                        ) && orderData.is_completed == 0
                      " class="delete colorRed" @click="
                        deleteRecord(file.id, 'deleteProjectDocumentFile')
                        ">刪除</a>
                    </div>
                  </template>
                  <template #cell(actions)="data">
                    <b-dropdown v-if="
                      orderData.is_completed == 0 &&
                      (ability.can(
                        'project_stages_customer_document_update',
                        'order_detail'
                      ) ||
                        ability.can(
                          'project_stages_customer_document_delete',
                          'order_detail'
                        ))
                    " class="action-trigger-btn" :right="$store.state.appConfig.isRTL">
                      <template #button-content>
                        <feather-icon icon="EyeIcon" size="16" class="align-middle text-body" />
                      </template>

                      <b-dropdown-item v-if="
                        ability.can(
                          'project_stages_customer_document_update',
                          'order_detail'
                        )
                      " @click="handleModelDocument(data.item)">
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">編輯記錄</span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="
                        ability.can(
                          'project_stages_customer_document_delete',
                          'order_detail'
                        )
                      " @click="
                        deleteRecord(data.item.id, 'deleteProjectDocument')
                        ">
                        <feather-icon icon="Trash2Icon" />
                        <span class="align-middle ml-50">刪除記錄</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <!-- 施工圖 -->
        <b-card v-if="ability.can('project_drawings', 'order_detail')">
          <div style="background-color: #dec9b8" class="colored-tab-title">
            <div class="d-flex aling-items-center justify-content-between">
              <h4 class="d-flex aling-items-center p-1 mb-0 left-bold-border before-color-Black font-weight-bolder">
                施工圖
              </h4>
              <div class="d-flex align-items-center">
                <b-button variant="primary" class="d-flex py-50 px-2 align-items-center" @click="handleDrawing(false)"
                  v-if="
                    ability.can(
                      'project_drawings_document_upload',
                      'order_detail'
                    ) && orderData.is_completed == 0
                  ">
                  <feather-icon icon="PlusIcon" size="20" />
                  新增
                </b-button>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <b-table ref="refDrawingImageTable" class="position-relative table-drawing"
              :items="orderData.project_drawings" responsive :fields="drawingImagetableColumns" primary-key="id"
              show-empty empty-text="未找到匹配的記錄">
              <template #cell(uploader)="data">
                {{ (data.item.creator && data.item.creator.name_cn) || data.item.uploader_name_cn || '-' }}
              </template>
              <template #cell(approver)="data">
                {{ (data.item.approver && data.item.approver.name_cn) || data.item.approver_name_cn || '-' }}
              </template>
              <!-- Column: drawing_status -->
              <template #cell(drawing_status)="data">
                <div :style="{
                  color: data.item.is_approved == 1 ? '#28a745' :
                         data.item.is_approved == -1 ? '#dc3545' : '#6c757d'
                }">
                  {{
                    data.item.is_approved == 1 ? '已簽收' :
                    data.item.is_approved == -1 ? '待修正' : '待檢閱'
                  }}
                </div>
              </template>

              <template #cell(file_url)="data">
                <a class="color1" @click="
                  previewImageSet(
                    orderData.project_drawings,
                    data.index,
                    'project_drawings'
                  )
                  ">檔案預覽</a>
              </template>

              <!-- Column: created_at -->
              <template #cell(created_at)="data">
                {{ getCorrectDateTime(data.item.created_at) }}
              </template>

              <template #cell(files)="data">
                <div class="d-flex" v-for="file of data.item.files" :key="`files${file.id}`">
                  <a class="d-flex" target="_blank" :download="file.file_name" :href="file.image_path">
                    <span class="download-text d-inline-block">{{
                      file.file_name
                    }}</span>
                  </a>
                  <a v-if="
                    orderData.is_completed == 0 &&
                    ability.can(
                      'project_drawings_document_delete',
                      'order_detail'
                    )
                  " class="delete colorRed" @click="deleteRecord(file.id, 'deleteProjecDrawingFile')">刪除</a>
                </div>
              </template>
               <template #cell(approve_files)="data">
                <div v-if="data.item.approve_files && data.item.approve_files.length > 0">
                  <div class="d-flex" v-for="file of data.item.approve_files" :key="`files${file.id}`">
                    <a class="d-flex" target="_blank" :download="file.file_name" :href="file.image_path">
                      <span class="download-text d-inline-block">{{
                        file.file_name
                      }}</span>
                      <!-- 下載 -->
                    </a>
                    <!-- <span class="color1 mx-50">|</span> -->
                    <a v-if="
                      orderData.is_completed == 0 &&
                      ability.can('comment_delete', 'order_detail')
                    " class="delete colorRed" @click="deleteRecord(file.id, 'deleteProjectDrawingApproveFile')">刪除</a>
                  </div>
                </div>
                <div v-else>- -</div>
              </template>

              <template #cell(remark)="data">
                <div style="width:280px; white-space: break-spaces;">{{ data.item.remark }}</div>
              </template>

              <template #cell(is_approved)="data">
                <feather-icon v-if="data.item.is_approved == 1" icon="CheckIcon" size="18" class="mr-50 text-success" />
                <feather-icon v-if="data.item.is_approved == -1" icon="XIcon" size="18" class="mr-50 text-danger" />
              </template>
              
              <template #cell(approved_at)="data">
                {{ getCorrectDateTime(data.item.approved_at) }}
              </template>



              <template #cell(show_details)="row">
                <b-button v-if="row.item.is_approved === -1" size="sm" @click="row.toggleDetails()" class="mr-2">
                  {{ row.detailsShowing ? "隱藏" : "顯示" }}
                </b-button>
                <div v-else>- -</div>
              </template>

              <template #row-details="row">
                <b-card class="backgroundColor5" v-if="row.item.is_approved === -1">
                  <div class="mb-2 d-flex">
                    <span class="font-weight-bolder">拒絕批准原因：</span>
                    <span>{{ row.item.approve_remark }}</span>
                  </div>
                  <div class="" v-if="
                    row.item.approve_files &&
                    row.item.approve_files.length > 0
                  ">
                    <div class="d-flex align-items-center" v-for="file of row.item.approve_files"
                      :key="`files${file.id}`">
                      <div style="width: 560px; height: 300px" class="d-flex justify-content-center align-items-center">
                        <img style="max-width: 100%; max-height: 100%" :src="file.image_path" alt="file.file_name" />
                      </div>
                      <a class="d-flex" target="_blank" :download="file.file_name" :href="file.image_path">
                        <span class="ml-2 d-inline-block">{{
                          file.file_name
                        }}</span>
                      </a>
                      <div v-if="
                        ability.can(
                          'project_drawings_reject_approve_update',
                          'order_detail'
                        ) && orderData.is_completed == 0
                      " class="d-flex align-items-center ml-2">
                        <feather-icon class="cursor-pointer" @click="handleDrawingApproval(row.item)" icon="EditIcon" />
                        <span class="mx-50">|</span>
                        <feather-icon class="cursor-pointer" v-if="
                          ability.can(
                            'project_drawings_reject_approve_delete',
                            'order_detail'
                          ) && orderData.is_completed == 0
                        " @click="
                          deleteRecord(
                            file.id,
                            'deleteProjectDrawingApproveFile'
                          )
                          " icon="Trash2Icon" />
                      </div>
                    </div>
                  </div>
                </b-card>
              </template>
              <template #cell(actions)="data">
                <b-dropdown v-if="
                  orderData.is_completed == 0 &&
                  (ability.can(
                    'project_drawings_document_update',
                    'order_detail'
                  ) ||
                    ability.can('project_drawings_approve', 'order_detail') ||
                    ability.can(
                      'project_drawings_document_delete',
                      'order_detail'
                    ))
                " :class="`action-trigger-btn ${orderData.project_drawings.length <= 3 ? 'hor' : 'ver'
                  }`" :right="$store.state.appConfig.isRTL">
                  <template #button-content class="">
                    <feather-icon icon="EyeIcon" size="16" class="align-middle text-body" />
                  </template>

                  <b-dropdown-item v-if="
                    ability.can(
                      'project_drawings_document_update',
                      'order_detail'
                    )
                  " @click="handleDrawing(data.item)">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">修改文件</span>
                  </b-dropdown-item>

                  <b-dropdown-item v-if="
                    ability.can('project_drawings_approve', 'order_detail') &&
                    data.item.is_approved == 0
                  " @click="handleDrawingApproval(data.item)">
                    <feather-icon icon="CheckIcon" />
                    <span class="align-middle ml-50">更改批核狀態</span>
                  </b-dropdown-item>

                  <b-dropdown-item v-if="
                    ability.can(
                      'project_drawings_document_delete',
                      'order_detail'
                    )
                  " @click="deleteRecord(data.item.id, 'deleteProjecDrawing')">
                    <feather-icon icon="Trash2Icon" />
                    <span class="align-middle ml-50">刪除記錄</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </b-card>

        <!-- 評論記錄 -->
        <b-card v-if="ability.can('comment', 'order_detail')">
          <div style="background-color: #e9e4f0" class="colored-tab-title">
            <div class="d-flex aling-items-center justify-content-between">
              <h4 class="d-flex aling-items-center p-1 mb-0 left-bold-border before-color-Black font-weight-bolder">
                討論留言
              </h4>
              <div class="d-flex align-items-center">
                <b-button variant="primary" class="d-flex py-50 px-2 align-items-center" @click="handleMessage(false)"
                  v-if="
                    ability.can('comment_create', 'order_detail') &&
                    orderData.is_completed == 0
                  ">
                  <feather-icon icon="PlusIcon" size="20" />
                  新增
                </b-button>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <b-table ref="refMessageRecordTable" class="position-relative" :items="orderData.project_comments"
              responsive :fields="messageRecordTableColumns" primary-key="id" show-empty empty-text="未找到匹配的記錄">
              <template #cell(uploader)="data">
                {{ (data.item.creator && data.item.creator.name_cn) || data.item.uploader_name_cn || '-' }}
              </template>
              <!-- :sort-by.sync="sortBy"
                :sort-desc.sync="isSortDirDesc" -->

              <template #cell(project_comment_type_id)="data">
                <div :style="{
                  color: getCommentType(data.item.project_comment_type_id)
                    .color,
                }">
                  {{ getCommentType(data.item.project_comment_type_id).name }}
                </div>
              </template>

              <template #cell(file_url)="data">
                <a v-if="data.item.files && data.item.files.length > 0" class="color1" @click="
                  previewImageSet(
                    orderData.project_comments,
                    data.index,
                    'project_comments'
                  )
                  ">檔案預覽</a>

                <div v-else>- -</div>
              </template>

              <!-- Column: created_at -->
              <template #cell(created_at)="data">
                {{ getDateTime(data.item.created_at) }}
              </template>

              <template #cell(files)="data">
                <div v-if="data.item.files && data.item.files.length > 0">
                  <div class="d-flex" v-for="file of data.item.files" :key="`files${file.id}`">
                    <a class="d-flex" target="_blank" :download="file.file_name" :href="file.image_path">
                      <span class="download-text d-inline-block">{{
                        file.file_name
                      }}</span>
                      <!-- 下載 -->
                    </a>
                    <!-- <span class="color1 mx-50">|</span> -->
                    <a v-if="
                      orderData.is_completed == 0 &&
                      ability.can('comment_delete', 'order_detail')
                    " class="delete colorRed" @click="deleteRecord(file.id, 'deleteProjectMessageFile')">刪除</a>
                  </div>
                </div>
                <div v-else>- -</div>
              </template>
             

              <template #cell(actions)="data">
                <b-dropdown v-if="orderData.is_completed == 0" class="action-trigger-btn"
                  :right="$store.state.appConfig.isRTL">
                  <template #button-content class="">
                    <feather-icon icon="EyeIcon" size="16" class="align-middle text-body" />
                  </template>

                  <b-dropdown-item v-if="ability.can('comment_update', 'order_detail')"
                    @click="handleMessage(data.item)">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">修改文件</span>
                  </b-dropdown-item>

                  <b-dropdown-item v-if="ability.can('comment_delete', 'order_detail')"
                    @click="deleteRecord(data.item.id, 'deleteProjectMessage')">
                    <feather-icon icon="Trash2Icon" />
                    <span class="align-middle ml-50">刪除記錄</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </b-card>

        <!-- 收據 及 預約-->
        <b-row>
          <!-- 收據 -->
          <b-col md="6" v-if="ability.can('receipts', 'order_detail')">
            <b-card style="height: calc(100% - 2rem)">
              <div class="d-flex align-items-center justify-content-between">
                <h4 class="mb-0 ml-1 d-flex aling-items-center left-bold-border before-color-0 font-weight-bolder">
                  收據
                </h4>

                <!-- <b-button
                variant="primary"
                class="d-flex py-50 px-3 align-items-center"
                @click="handleModalSalaryRecord(false)"
              >
                <feather-icon icon="PlusIcon" size="20" />
                新增</b-button
              > -->
              </div>
              <div class="mt-2">
                <b-table ref="refReceiptListTable" class="position-relative" :items="receiptsList" responsive
                  :fields="receiptTablemColumns" primary-key="id" show-empty empty-text="未找到匹配的記錄">
                  <template #cell(payment_method)="data">
                    {{ getPaymentMethod(data.item.payment_method_id).name }}
                  </template>

                  <template #cell(id)="data">
                    <b-link :to="{ name: 'receipt-edit', params: { id: data.item.id } }" class="text-primary">
                      {{ data.item.receipt_number }}
                    </b-link>
                  </template>

                  <!-- Column: show_details receipt_items -->
                  <template #cell(show_details)="row">
                    <b-button v-if="row.item.receipt_items" size="sm" @click="row.toggleDetails" class="mr-2">
                      {{ row.detailsShowing ? "隱藏" : "顯示" }}
                    </b-button>
                  </template>
                  <!-- <template #row-details="row">
                    <b-row
                      class="p-2 backgroundColor5 mb-1"
                      v-for="(receipt, index) in row.item.receipt_items"
                      :key="`receipt${index}`"
                    >
                      <b-col cols="12" md="6" class="mb-50">
                        <span class="">收訂金日期：</span>
                        <span class="">{{ receipt.payment_date }}</span>
                      </b-col>
                      <b-col cols="12" md="6" class="mb-50">
                        <span class="">訂金金額：</span>
                        <span class="">{{ receipt.amount }}</span>
                      </b-col>
                      <b-col cols="12" md="6" class="mb-50">
                        <span class="">款項摘要：</span>
                        <span class="">{{ receipt.item_description }}</span>
                      </b-col>
                    </b-row>
                  </template> -->


                  <template #row-details="row">
                    <b-row class="p-2 backgroundColor5 mb-1" v-for="(receipt, index) in row.item.receipt_items"
                      :key="`receipt${index}`">
                      <b-col cols="12" md="4" class="mb-50">
                        <span class="">發票編號：</span>
                        <span class="">
                          <a v-if="receipt.invoice && receipt.invoice.invoice_number && receipt.invoice.id"
                            :href="$router.resolve({ name: 'invoice-edit', params: { id: receipt.invoice.id } }).href"
                            target="_blank" class="text-primary">
                            {{ receipt.invoice.invoice_number }}
                          </a>
                          <span v-else>
                            {{ receipt.invoice && receipt.invoice.invoice_number }}
                          </span>
                        </span>
                      </b-col>
                      <b-col cols="12" md="4" class="mb-50">
                        <span class="">付款日期：</span>
                        <span class="">{{ receipt.payment_date }}</span>
                      </b-col>
                      <b-col cols="12" md="4" class="mb-50">
                        <span class="">付款方式：</span>
                        <span class="">{{ receipt.payment_method && receipt.payment_method.name }}</span>
                      </b-col>
                      <b-col cols="12" md="4" class="mb-50">
                        <span class="">付款金額：</span>
                        <div v-if="receipt.is_reprint" class="reprint-amount text-warning">
                          <div class="font-weight-bold">${{ Number(receipt.amount).toFixed(2) }}</div>
                          <small class="text-muted">
                            (原額: ${{ getOriginalReceiptAmount(receipt) }})
                          </small>
                        </div>
                        <span v-else class="">${{ Number(receipt.amount).toFixed(2) }}</span>
                      </b-col>
                      <b-col cols="12" md="4" class="mb-50">
                        <!-- <span class="">款項摘要：</span> -->
                        <span class="" :class="{ 'text-warning': receipt.is_reprint }">
                          {{ receipt.payment_step ?
                            `${receipt.payment_step.step_phase} ${receipt.payment_step.step_name ? `：
                          ${receipt.payment_step.step_name}` : ''} - 金額：$${receipt.payment_step.step_amount}`
                            : '' }}
                          <span v-if="receipt.is_reprint" class="badge badge-warning ml-1">(Re-Print)</span>
                        </span>
                      </b-col>
                    </b-row>
                  </template>

                  <template #cell(export)="data">
                    <b-link  :to="{
                      name: 'receipt-preview',
                      params: { id: data.item.id },
                    }">
                      <feather-icon icon="FileTextIcon" />
                      <span class="align-middle ml-50">列印收據</span>
                    </b-link>
                  </template>

                  <template #cell(created_at)="data">
                    {{ getDateTime(data.item.created_at) }}
                  </template>
                </b-table>
              </div>
            </b-card>
          </b-col>
          <!-- 預約 -->
          <b-col md="6" v-if="ability.can('appointment', 'order_detail')">
            <b-card style="height: calc(100% - 2rem)" id="downloadWrapper">
              <div class="d-flex aling-items-center justify-content-between">
                <h4 class="d-flex aling-items-center p-1 mb-0 left-bold-border before-color-Black font-weight-bolder">
                  預約
                </h4>
                <div class="d-flex align-items-center">
                  <b-button variant="primary" class="d-flex py-50 px-2 align-items-center"
                    @click="handleAppointment(false)" v-if="
                      ability.can('appointment_create', 'order_detail') &&
                      orderData.is_completed == 0
                    ">
                    <feather-icon icon="PlusIcon" size="20" />
                    新增
                  </b-button>
                </div>
              </div>

              <div class="mt-2">
                <b-table ref="refAppointmentTable" class="position-relative" :items="orderData.project_bookings"
                  responsive :fields="appointmentTableColumns" primary-key="id" show-empty empty-text="未找到匹配的記錄">
                  <!-- :sort-by.sync="sortBy"
                :sort-desc.sync="isSortDirDesc" -->

                  <!-- Column: content（保留換行 / 富文字排版） -->
                  <template #cell(content)="data">
                    <div
                      class="appointment-content"
                      v-html="renderBookingContent(data.item.content)"
                    ></div>
                  </template>

                  <!-- Column: creator -->
                  <template #cell(creator)="data">
                    <div>
                      {{ data.item.creator ? (data.item.creator.name_cn || data.item.creator.name) : '-' }}
                    </div>
                  </template>

                  <template #cell(project_booking_status_id)="data">
                    <div :style="{
                      color: getBookingStatus(
                        data.item.project_booking_status_id
                      ).color,
                    }">
                      {{
                        getBookingStatus(data.item.project_booking_status_id)
                          .name
                      }}
                    </div>
                  </template>

                  <!-- Column: management -->
                  <template #cell(management)="data">
                    <div class="d-flex align-items-center">
                      <font-awesome-icon class="mr-50 cursor-pointer" icon="fas fa-pen" v-if="
                        ability.can('appointment_update', 'order_detail') &&
                        orderData.is_completed == 0
                      " @click="handleAppointment(data.item)" />
                      <template v-if="ability.can('appointment_delete', 'order_detail')">
                        /
                        <font-awesome-icon class="ml-50 cursor-pointer" @click="deleteAppointment(data.item.id)"
                          icon="fa-solid fa-trash" />
                      </template>
                    </div>
                  </template>
                </b-table>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <!-- 活動記錄 -->
        <!--
      <b-card>
        <div style="background-color: #c4e0fe" class="colored-tab-title">
          <div class="d-flex aling-items-center justify-content-between">
            <h4
              class="d-flex aling-items-center p-1 mb-0 left-bold-border before-color-Black font-weight-bolder"
            >
              活動記錄
            </h4>
            <div class="d-flex align-items-center">
              <b-button
                variant="primary"
                class="d-flex py-50 px-2 align-items-center"
                @click="handleActivitice(false)"
                v-if="ability.can('update', 'orders') && orderData.is_completed == 0"
              >
                <feather-icon icon="PlusIcon" size="20" />
                新增
              </b-button>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <b-table
            ref="refActivityTable"
            class="position-relative"
            :items="orderData.project_activities"
            responsive
            :fields="activityTableColumns"
            primary-key="id"
            show-empty
            empty-text="未找到匹配的記錄"
          >
            <template #cell(activity_type)="data">
              {{ data.item.activity_type && data.item.activity_type.name }}
            </template>

            <template #cell(start_date)="data">
              {{ data.item.start_date }}
            </template>

            <template #cell(end_date)="data">
              {{ data.item.end_date }}
            </template>

            <template #cell(workers)="data">
              {{ data.item.workers.map((ele) => ele.name).toString() }}
            </template>

            <template #cell(actions)="data">
              <div v-if="orderData.is_completed == 0" class="d-flex align-items-center">
                <a class="mr-50" @click="handleActivitice(data.item)">
                  <feather-icon icon="EditIcon" />
                </a>
                /
                <font-awesome-icon
                  class="cursor-pointer ml-50"
                  v-if="ability.can('delete', 'worker') || true"
                  @click="deleteRecord(data.item.id, 'deleteProjectActivitice')"
                  icon="fa-solid fa-trash"
                />
              </div>
            </template>
          </b-table>
        </div>
      </b-card> -->
        <!-- 工資 -->
        <div class="mt-2">
          <b-card v-if="
            ability.can('salary_records', 'order_detail') &&
            orderData.salary_records &&
            orderData.salary_records.length > 0
          ">
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="mb-0 ml-0 d-flex aling-items-center left-bold-border before-color-1 font-weight-bolder">
                工資
              </h4>
            </div>
            <div class="mt-2 info-container">
              <b-row class="p-2 m-0 radius-round backgroundColor5 mb-1"
                v-for="(worker, index) in orderData.salary_records" :key="`worker${index}`">
                <b-col cols="12" md="6">
                  <div class="row mb-50">
                    <b class="label">師傅:</b>
                    <span>{{
                      worker && worker.user && worker.user.name_cn
                    }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">職位：</b>
                    <span>{{
                      findWorker(worker.user_id, workerOptions).position
                    }}</span>
                  </div>
                  <div class="row mb-50">
                    <b class="label">工資：</b>
                    <span>{{ worker.working_days }} X ${{ worker.day_salary }}日 =
                      ${{ worker.total_salary }}
                    </span>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="row mb-50">
                    <b class="label">開工日期</b>
                    <span>{{ formatWorkingDate(worker.working_date) }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </div>
        <!-- 薪金支出 -->
        <!-- <div class="mt-2">
          <b-card
            v-if="
              orderData.expense_items &&
              orderData.expense_items.length > 0 &&
              ability.can('expense_items', 'order_detail')
            "
          >
            <div class="d-flex align-items-center justify-content-between">
              <h4
                class="mb-0 ml-0 d-flex aling-items-center left-bold-border before-color-2 font-weight-bolder"
              >
                其他薪金支出
              </h4>
            </div>
            <div class="mt-2 info-container">
              <b-row
                class="p-2 m-0 radius-round backgroundColor3 mb-1"
                v-for="(cost, index) in orderData.expense_items"
                :key="`cost${index}`"
              >
                <b-col cols="12" md="6">
                  <div class="d-flex mb-50">
                    <b class="label">商品：</b>
                    <span>{{ getProduct(cost.product_id).product_name }}</span>
                  </div>
                  <div class="d-flex mb-50">
                    <b class="label">總金額：</b>
                    <span
                      >{{ parseFloat(Number(cost.quantity).toString())}} X ${{ cost.unit_price }} = ${{
                        cost.total
                      }}</span
                    >
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="d-flex mb-50">
                    <b class="label">備註：</b>
                    <span>{{ cost.remark }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </div> -->
      </div>
      <div v-if="user_type_id == 2 && project_list.length == 0">
        <h4 class="d-flex justify-content-center">未找到匹配的記錄</h4>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BTable,
  BRow,
  BCol,
  BAlert,
  BLink,
  BButton,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BCollapse,
  BSpinner,
  BBadge,
  VBToggle,
  BSidebar,
} from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import vSelect from "vue-select";
import router from "@/router";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";
import orderStoreModule from "../orderStoreModule";
import ability from "@/libs/acl/ability";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

import ModalDocument from "../modal/ModalDocument";
import ModalPdf from "@/layouts/components/file/ModalPdf.vue";
import ModalImageViewer from "@/layouts/components/file/ModalImageViewer.vue";
import ModalMessage from "../modal/ModalMessage.vue";
import ModalAppointment from "../modal/ModalAppointment.vue";
import { toDisplayHtml } from "@/libs/rich-text";
import ModalActivitice from "../modal/ModalActivitice.vue";
import ModalProgressEdit from "../modal/ModalProgressEdit.vue";
import ModalDrawing from "../modal/ModalDrawing.vue";
import ModalDrawingApproval from "../modal/ModalDrawingApproval.vue";
import ModalStageDocument from "../modal/ModalStageDocument.vue";
import { formatWorkingDate } from "@/utils/dateFormatter";

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BRow,
    BCol,
    BAlert,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner,
    BOverlay,
    BCollapse,
    BBadge,
    VBToggle,
    BSidebar,
    vSelect,
    AppTimeline,
    AppTimelineItem,
    ModalDocument,
    ModalPdf,
    ModalImageViewer,
    ModalMessage,
    ModalActivitice,
    ModalAppointment,
    ModalProgressEdit,
    ModalDrawing,
    ModalDrawingApproval,
    ModalStageDocument,
  },
  data() {
    return {
      ability,
      documentData: {},
      pdfUrl: null,
      loadingPDF: false,
      title: null,
      previewImage: null,
      selectedTime: 1,
      custome_id: null,
      selected_file: null,
      approveData: {},
      stageDocumentData: {},
      show_all_images_id: null,
      // 獨立管理兩種詳情顯示狀態
      detailsShowing: {}, // 項目摘要詳情顯示狀態 { invoiceId: boolean }
      paymentStepsShowing: {}, // 階段收費詳情顯示狀態 { invoiceId: boolean }
    };
  },
  directives: {
    "b-toggle": VBToggle,
  },
  methods: {
    formatCurrency,
    hide() {
      this.$router.go(-1);
    },
    handleDrawingApproval(item) {
      if (item) {
        this.approveData = item;
      } else {
        this.approveData = { id: 0 };
      }
      this.$bvModal.show("modal-drawing-approval");
    },
    selectTime(id) {
      this.selectedTime = id;
    },
    handleProgressEdit() {
      this.$bvModal.show("modal-progress-edit");
    },
    handleStageModelDocument(item) {
      this.stageDocumentData = {
        files: item.files,
        project_stage_info_id: item.id,
      };

      this.$bvModal.show("modal-stage-document");
    },
    showAllImages(item) {
      if (this.show_all_images_id == item.id) {
        this.show_all_images_id = null;
      } else {
        this.show_all_images_id = item.id;
      }
    },
    preview_stage_images(item, index) {
      var files = item.files.map((ele) => {
        return {
          id: ele.id,
          src: ele.image_path,
          type:
            ele.image_path.indexOf("pdf") > -1
              ? "application/pdf"
              : "image/jpeg",
        };
      });
      this.previewImage = files;
      this.selected_file = index;
      this.custome_id = "-stage";
      setTimeout(() => {
        this.$bvModal.show(`modal-image-viewer-stage`);
      });
    },
    handleDrawing(item) {
      if (item) {
        this.drawingData = item;
      } else {
        this.drawingData = { id: 0 };
      }
      this.$bvModal.show("modal-drawing");
    },
    handleMessage(item) {
      if (item) {
        this.messageData = item;
      } else {
        this.messageData = { id: 0 };
      }
      this.$bvModal.show("modal-message");
    },
    /** 預約內容可能是舊的純文字（\n 換行）或新的 Quill HTML，統一轉成可顯示的 HTML */
    renderBookingContent(content) {
      return toDisplayHtml(content);
    },
    handleAppointment(item) {
      if (item) {
        this.appointmentData = item;
      } else {
        this.appointmentData = { id: 0 };
      }
      this.$bvModal.show("modal-appointment");
    },
    handleModelDocument(item) {
      if (item) {
        this.documentData = item;
      } else {
        this.documentData = { id: 0 };
      }
      this.$bvModal.show("modal-document");
    },
    handleActivitice(item) {
      if (item) {
        this.activiticeData = item;
      } else {
        this.activiticeData = { id: 0 };
      }
      this.$bvModal.show("modal-activitice");
    },
    deleteRecord(id, apiKey) {
      // 設定不同的確認訊息
      let confirmText = "您的行動是最終的，您將無法檢索項目記錄。";
      if (apiKey === 'deleteProjecDrawing') {
        confirmText = "您將刪除此施工圖記錄及其所有相關檔案，此操作無法復原。";
      } else if (apiKey === 'deleteProjecDrawingFile' || apiKey === 'deleteProjectDrawingApproveFile') {
        confirmText = "您將刪除此檔案。";
      }

      this.$swal({
        title: "你確定嗎?",
        text: confirmText,
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          // 直接使用傳入的 apiKey，不做特殊處理
          const params = { id: id };


          this.$store
            .dispatch(`order/${apiKey}`, params)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    previewImageSet(data, index, key) {
      this.previewImage = [];
      data.forEach((item) => {
        if (item.files && item.files.length > 0) {
          var arr = item.files.map((ele) => {
            return {
              id: ele.id,
              src: ele.image_path,
              type:
                ele.image_path.indexOf("pdf") > -1
                  ? "application/pdf"
                  : "image/jpeg",
            };
          });
          this.previewImage = [...this.previewImage, ...arr];
        }
      });
      this.selected_file = index;
      this.custome_id = key;
      setTimeout(() => {
        this.$bvModal.show(`modal-image-viewer${key}`);
      });
    },
    projectSearch(options, search) {
      return options.filter((item) => {
        return item.project_name.toLowerCase().includes(search.toLowerCase());
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    // 項目摘要詳情管理方法
    toggleItemDetails(row) {
      const invoiceId = row.item.id;
      const wasPaymentStepsShowing = this.paymentStepsShowing[invoiceId];
      const wasItemDetailsShowing = this.detailsShowing[invoiceId];

      // 關閉階段收費詳情（如果開啟的話）
      this.$set(this.paymentStepsShowing, invoiceId, false);
      // 切換項目摘要詳情
      this.$set(this.detailsShowing, invoiceId, !wasItemDetailsShowing);

      // 只有在需要時才調用 row.toggleDetails()
      if (!wasPaymentStepsShowing && !wasItemDetailsShowing) {
        // 如果之前兩個都沒有顯示，需要打開 row details
        row.toggleDetails();
      } else if (
        !this.detailsShowing[invoiceId] &&
        !this.paymentStepsShowing[invoiceId]
      ) {
        // 如果現在兩個都沒有顯示，需要關閉 row details
        row.toggleDetails();
      }
    },

    getItemDetailsShowing(invoiceId) {
      return !!this.detailsShowing[invoiceId];
    },

    // 階段收費詳情管理方法
    togglePaymentStepsDetails(row) {
      const invoiceId = row.item.id;
      const wasItemDetailsShowing = this.detailsShowing[invoiceId];
      const wasPaymentStepsShowing = this.paymentStepsShowing[invoiceId];

      // 關閉項目摘要詳情（如果開啟的話）
      this.$set(this.detailsShowing, invoiceId, false);
      // 切換階段收費詳情
      this.$set(this.paymentStepsShowing, invoiceId, !wasPaymentStepsShowing);

      // 只有在需要時才調用 row.toggleDetails()
      if (!wasItemDetailsShowing && !wasPaymentStepsShowing) {
        // 如果之前兩個都沒有顯示，需要打開 row details
        row.toggleDetails();
      } else if (
        !this.detailsShowing[invoiceId] &&
        !this.paymentStepsShowing[invoiceId]
      ) {
        // 如果現在兩個都沒有顯示，需要關閉 row details
        row.toggleDetails();
      }
    },

    getPaymentStepsShowing(invoiceId) {
      return !!this.paymentStepsShowing[invoiceId];
    },

    // 獲取階段收費數據（兼容不同的數據格式）
    getPaymentStepsData(item) {
      // 優先使用 paymentSteps（後端關聯名稱），其次使用 payment_steps
      return item.paymentSteps || item.payment_steps || [];
    },
    getProductCategory(id) {
      if (
        !id ||
        !this.productCategoriesOptions ||
        !this.productCategoriesOptions.length
      ) {
        return null;
      }
      return this.productCategoriesOptions.find(function (ele) {
        return ele.id === id;
      });
    },
    formatWorkingDate,
  },

  setup() {
    const orderData = ref(null);
    const ORDER_APP_STORE_MODULE_NAME = "order";

    if (!store.hasModule(ORDER_APP_STORE_MODULE_NAME))
      store.registerModule(ORDER_APP_STORE_MODULE_NAME, orderStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ORDER_APP_STORE_MODULE_NAME))
        store.unregisterModule(ORDER_APP_STORE_MODULE_NAME);
    });

    const selected_project_id = ref(null);

    const documentTableColumns = ref([
      {
        key: "name",
        stickyColumn: true,
        label: "檔案名稱",
        sortable: true,
      },
      { key: "file_url", label: "預覽", sortable: true },
      { key: "created_at", label: "上傳日期", sortable: true },
      { key: "files", label: "文件列表" },
      { key: "actions", label: "操作", sortable: true },
    ]);

    const invoiceColumns = [
      { key: "invoice_number", label: "編號", class: 'sticky-column', sortable: true },
      { key: "invoice_date", class: 'sticky-column', label: "發單日期", sortable: true },
      { key: "actions", label: "操作", class: 'sticky-column' },
      { key: "show_details2", label: "階段收費" },
      { key: "show_details", label: "項目摘要" },
      { key: "stamp", label: "公司印章" },
      { key: "customer.name_cn", label: "單據抬頭" },
      { key: "invoice_type", label: "類別" },
      { key: "project_name", label: "項目名稱", sortable: true },
      { key: "address", label: "施工地址", sortable: true },
      { key: "amount", label: "總價", sortable: true, formatter: formatCurrency },
      // { key: "deposit_amount", label: "第一次付款金額", sortable: true, formatter: formatCurrency },
      // { key: 'total_deposit_paid', label: "已付第一次付款", formatter: formatCurrency },
      { key: 'total_paid', label: "已付", formatter: formatCurrency },
      { key: 'total_unpaid', label: "未付", formatter: formatCurrency },
      { key: 'total_refund', label: "總退款額", formatter: formatCurrency },
      { key: 'total_bad_debt_amount', label: "總壞帳額", formatter: formatCurrency },
      // { key: "deposit_due_date", label: "第一次付款截止日期", sortable: true },
      // { key: "deposit_paid_date", label: "第一次付款支付期日", sortable: true },
      /* 
      { key: "name_en", label: "系統帳號名稱" }, */
      { key: "mobile", label: "聯絡電話" },
      { key: "email", label: "電郵地址" },
      { key: "quotation_id", label: "報價單編號", sortable: true },
      { key: "created_at", label: "創建日期", sortable: true },
    ];

    const drawingImagetableColumns = ref([
      { key: "name", stickyColumn: true, label: "文件名稱", sortable: true },
      { key: "uploader", label: "上傳者" },
      { key: "remark", label: "備註", sortable: true },
      { key: "drawing_status", label: "狀態" },
      { key: "created_at", label: "上傳日期", sortable: true },
      { key: "files", label: "文件列表" },
      { key: "is_approved", label: "批核/拒絕", sortable: true },
      { key: "approve_files", label: "修正文件" },
      { key: "actions", label: "操作", sortable: true },
      { key: "approver", label: "審批者" },
      { key: "approved_at", label: "審批日期", sortable: true },
      { key: "file_url", label: "所有檔案", sortable: true },
      // { key: "show_details", label: "批核摘要" },
    ]);

    const messageRecordTableColumns = ref([
      { key: "id", stickyColumn: true, label: "討論編號", sortable: true },
      { key: "uploader", label: "發起人" },
      { key: "name", label: "主題", sortable: true },
      { key: "remark", label: "討論摘要" },
      { key: "created_at", label: "討論日期", sortable: true },
      { key: "files", label: "文件列表" },
      { key: "actions", label: "操作", sortable: true },
      { key: "file_url", label: "所有檔案", sortable: true },
    ]);
    const receiptTablemColumns = ref([
      { key: "id", stickyColumn: true, label: "收據編號", sortable: true },
      { key: "address", label: "施工地址", sortable: true },
      { key: "export", label: "列印收據", sortable: true },
      { key: "show_details", label: "支付項目", sortable: true },
      { key: "amount", label: "金額", formatter: formatCurrency },
      { key: "payment_method.name", label: "收款方式", sortable: true },
      { key: "receipt_date", label: "收據日期", sortable: true },
    ]);
    const appointmentTableColumns = ref([
      {
        key: "booking_time",
        stickyColumn: true,
        label: "預約日期及時間",
        sortable: true,
      },
      {
        key: "booking_title",
        label: "預約主題",
        sortable: true,
      },
      {
        key: "content",
        label: "預約內容",
        sortable: true,
        thStyle: { minWidth: "240px" },
      },
      { key: "creator", label: "預約人", sortable: true },
      { key: "project_booking_status_id", label: "狀態" },
      { key: "management", label: "管理" },
    ]);
    const activityTableColumns = ref([
      {
        key: "activity_type",
        stickyColumn: true,
        label: "活動類別",
        sortable: true,
      },
      { key: "details", label: "活動摘要", sortable: true },
      { key: "start_date", label: "開始日期" },
      { key: "end_date", label: "結束日期", sortable: true },
      { key: "workers", label: "負責師傅", sortable: true },
      { key: "actions", label: "操作" },
    ]);

    const progressList = ref([]);
    const project_list = ref([]);
    const project_id = ref(null);

    const user_type_id = ref(null);
    const user_id = ref(null);

    const monthList = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const loading = ref(true);

    const fetchProject = (id) => {
      selected_project_id.value = id;
      return store
        .dispatch("order/fetchProject", { id })
        .then((response) => {
          orderData.value = response.data.project;
          project_id.value = response.data.project.id;
          progressList.value = orderData.value.project_stages;
          initalFetch.value = false;
          loading.value = false;
          console.log(orderData.value);
        })
        .catch((error) => {
          loading.value = false;
          console.log("error when fetching project", error);
          if (error.response && error.response.status === 404) {
            orderData.value = undefined;
          }
        });
    };

    const initalFetch = ref(true);
    const fetchProjects = () => {
      loading.value = true;
      return store
        .dispatch("order/fetchProjects", {
          customer_id: user_id.value,
        })
        .then((response) => {
          project_list.value = response.data.projects;
          selected_project_id.value = selected_project_id.value
            ? selected_project_id.value
            : response.data.projects[0]?.id;
          return fetchProject(selected_project_id.value);
        })
        .catch((error) => {
          console.log("error when fetching project", error);
          loading.value = false;
          if (error.response && error.response.status === 404) {
            orderData.value = undefined;
          }
        });
    };

    const drawingData = ref(null);

    const appointmentData = ref(null);

    const messageData = ref(null);

    const receiptsList = ref([]);
    const fetchReceipts = () => {
      store
        .dispatch("order/fetchReceipts", {
          project_id: router.currentRoute.params.id || selected_project_id.value,
          // payment_method_id: filter_payment_method_id.value,
        })
        .then((response) => {
          const { receipts, total } = response.data;
          receiptsList.value = receipts;
        })
        .catch((err) => {
          console.log(err);
          toast({
            component: ToastificationContent,
            props: {
              title: "獲取貸款清單時出錯",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const invoicesList = ref([]);
    const fetchInvoices = () => {
      store
        .dispatch("order/fetchInvoices", {
          project_id: router.currentRoute.params.id || selected_project_id.value,
          // payment_method_id: filter_payment_method_id.value,
        })
        .then((response) => {
          const { invoices, total } = response.data;
          invoicesList.value = invoices;
        })
        .catch((err) => {
          console.log(err);
          toast({
            component: ToastificationContent,
            props: {
              title: "獲取貸款清單時出錯",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    // 切換項目時，除了項目本身，發票與收據清單也要一併重新載入
    const onProjectChange = (id) => {
      if (!id) return;
      return fetchProject(id).then(() => {
        fetchReceipts();
        fetchInvoices();
      });
    };

    const activiticeData = ref([]);

    const getBookingStatus = (id) => {
      if (!bookingStatusOptions.value?.length || !id)
        return { name: "- -", color: "#999" };
      return (
        bookingStatusOptions.value.find((ele) => ele.id == id) || {
          name: "- -",
          color: "#999",
        }
      );
    };

    const getCommentType = (id) => {
      if (!commentTypeOptions.value?.length || !id)
        return { name: "- -", color: "#999" };
      return (
        commentTypeOptions.value.find((ele) => ele.id == id) || {
          name: "- -",
          color: "#999",
        }
      );
    };

    const getActiviticeType = (id) => {
      if (!activiticeTypeOptions.value?.length || !id) return { name: "- -" };
      return (
        activiticeTypeOptions.value.find((ele) => ele.id == id) || {
          name: "- -",
        }
      );
    };

    const getInvoiceType = (id) => {
      if (!invoiceTypeOptions.value?.length || !id) return { name: "- -" };
      return (
        invoiceTypeOptions.value.find((ele) => ele.id == id) || { name: "- -" }
      );
    };

    const getQuotation = (id) => {
      if (!quotationOptions.value?.length || !id)
        return { quotation_number: "- -" };
      const obj = quotationOptions.value.find((ele) => ele.id == id) || {
        quotation_number: "- -",
      };
      return { ...obj };
    };

    const getProduct = (id) => {
      if (!productOptions.value?.length || !id)
        return { product_name: "- -", unit: "次" };
      const obj = productOptions.value.find((ele) => ele.id == id) || {
        product_name: "- -",
      };
      return { ...{ unit: "次" }, ...obj };
    };

    const getPaymentMethod = (id) => {
      if (!paymentMethodOptions.value?.length || !id) return { name: "- -" };
      return (
        paymentMethodOptions.value.find((ele) => ele.id == id) || {
          name: "- -",
        }
      );
    };

    // const bookingStatusOptions = ref([
    //   { id: 1, name: "待確定", color: "#3a34eb" },
    //   { id: 2, name: "已確定", color: "#00ff00" },
    //   { id: 3, name: "已取消", color: "#ff0000" },
    // ]);

    // const commentTypeOptions = ref([
    //   { id: 1, name: "施工時", color: "#3a34eb" },
    //   { id: 2, name: "已完工", color: "#00ff00" },
    //   { id: 3, name: "已取消", color: "#ff0000" },
    // ]);

    // const activiticeTypeOptions = ref([
    //   { id: 1, name: "清拆" },
    //   { id: 2, name: "維修" },
    //   { id: 3, name: "安裝" },
    // ]);

    const bookingStatusOptions = ref([]);
    const commentTypeOptions = ref([]);
    const activiticeTypeOptions = ref([]);
    const invoiceTypeOptions = ref([]);
    const projectStatusesOptions = ref([]);
    const progressEventOptions = ref([]);
    const paymentMethodOptions = ref([]);
    const productOptions = ref([]);
    const workerOptions = ref([]);
    const userOptions = ref([]);
    const quotationOptions = ref([]);
    const productCategoriesOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          project_booking_statuses: true,
          project_comment_types: true,
          activity_types: true,
          quotation_types: true,
          project_statuses: true,
          progress_events: true,
          payment_methods: true,
          products: true,
          product_categories: true,
          workers: true,
          users: true,
          quotations: true,
        })
        .then((response) => {
          bookingStatusOptions.value = response.data.project_booking_statuses;
          commentTypeOptions.value = response.data.project_comment_types;
          activiticeTypeOptions.value = response.data.activity_types;
          invoiceTypeOptions.value = response.data.quotation_types;
          projectStatusesOptions.value = response.data.project_statuses;
          quotationOptions.value = response.data.quotations;
          progressEventOptions.value = response.data.progress_events;
          paymentMethodOptions.value = response.data.payment_methods;
          workerOptions.value = response.data.workers;
          userOptions.value = response.data.users;
          productOptions.value = response.data.products;
          productCategoriesOptions.value = response.data.product_categories;
        });
    };

    const refetchData = () => {
      if (user_type_id.value === 2) {
        fetchProjects().then(() => {
          fetchReceipts();
          fetchInvoices();
        });
      } else {
        fetchProject(router.currentRoute.params.id).then(() => {
          fetchReceipts();
          fetchInvoices();
        });
      }
    };

    onMounted(() => {
      user_type_id.value = JSON.parse(
        localStorage.getItem("userData")
      ).user_type_id;
      user_id.value = JSON.parse(localStorage.getItem("userData")).id;
      refetchData();
      refetchOption();
    });

    const findCompletedItem = (list, item) => {
      const arr = list.filter((ele) => ele.project_stage.is_completed === 1);
      if (arr.length > 0 && arr.findIndex((ele) => ele.id == item.id) > -1) {
        return true;
      } else {
        return false;
      }
    };

    const findLastCompleted = (item) => {
      console.log(item);
      const target = item.findLastIndex(
        (ele) => ele.project_stage.is_completed === 1
      );
      return target;
    };

    const getProjectStatus = (id) => {
      return (
        projectStatusesOptions.value?.find((ele) => ele.id === id)?.name || ""
      );
    };

    const getManager = (id) => {
      return userOptions.value?.find((ele) => ele.id === id)?.name_cn || "";
    };

    // 新增一個工具函數來安全地查找worker
    const findWorker = (workerId, workers) => {
      if (!workers || !workers.length) return { name_cn: "--", position: "--" };
      return (
        workers.find((w) => w.id === workerId) || {
          name_cn: "--",
          position: "--",
        }
      );
    };

    return {
      orderData,
      project_id,
      documentTableColumns,
      drawingImagetableColumns,
      messageRecordTableColumns,
      receiptTablemColumns,
      appointmentTableColumns,
      activityTableColumns,
      invoiceColumns,
      refetchData,
      appointmentData,
      messageData,
      drawingData,
      progressList,
      receiptsList,
      invoicesList,
      monthList,
      activiticeData,
      getBookingStatus,
      getCommentType,
      getActiviticeType,
      getQuotation,
      getProduct,
      getInvoiceType,
      getPaymentMethod,
      progressEventOptions,
      bookingStatusOptions,
      projectStatusesOptions,
      commentTypeOptions,
      activiticeTypeOptions,
      workerOptions,
      quotationOptions,
      invoiceTypeOptions,
      paymentMethodOptions,
      productCategoriesOptions,
      findLastCompleted,
      findCompletedItem,
      getProjectStatus,
      getManager,
      selected_project_id,
      onProjectChange,
      project_list,
      fetchProject,
      loading,
      user_type_id,
      user_id,
      findWorker,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";

/* 預約內容：保留使用者輸入的換行與清單排版 */
.appointment-content {
  white-space: pre-line;
  word-break: break-word;

  p {
    margin-bottom: 0;
    white-space: normal;
  }

  ul,
  ol {
    margin-bottom: 0;
    padding-left: 1.25rem;
  }
}

@media (min-width: 540px) {
  .order-table-invoice {
    .sticky-column {
      &:nth-child(3) {
        width: 110px !important;
        min-width: 110px !important;
        max-width: 110px !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.info-wrap {
  .info-label {
    display: inline-block;
    width: 100px;
  }

  .info-item {
    margin-bottom: 1rem;

    .icon {
      display: inline-block;
      margin-right: 1rem;
      width: 15px;

      svg {
        margin: auto;
        display: block;
      }
    }
  }
}

.time-list {
  .time-part {
    margin-right: 1rem;

    .month {
      text-align: center;
    }

    .day {
      text-align: center;
      width: 30px;
      height: auto;
      aspect-ratio: 1/1;
      border-radius: 100%;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ececec;
    }
  }

  &.active {
    .time-part {
      .day {
        background-color: #3998fc;
        color: #fff;
      }
    }

    .info-part {
      background-color: transparent;
      border: 1px solid #3998fc;
    }

    .badge {
      padding: 0.5rem 0.5rem;
      line-height: 12px;
    }
  }

  .info-part {
    padding: 0 1rem;
    border-radius: 0.375rem;
    background-color: #ececec;
    width: 100%;

    .desc {
      color: #1b998b77;
    }

    .stage {
      border: 1px solid #69c1f8;
      color: #69c1f8;
      background: transparent;
    }

    .current-stage {
      background: #69c1f8;
      color: #fff;
    }
  }
}

.table-drawing {
  .b-table-sticky-column {}
}

@media screen and (max-width: 575px) {
  .expenditure-box {
    b {
      display: inline-block;
      width: 90px;
    }
  }
}
</style>
